import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg" fill="#F1281B" {...props}><rect y="7" width="7" height="7" rx="2" transform="rotate(-45 0 7)" /></svg>);